import React from "react";
import { VideoPopup } from "./VideoPopup";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { CreativeType } from "../../types/types";

interface props {
  item: {
    stage: string;
    title: string;
    thumbLink: string;
    videoLink: string;
    dt: string;
    orientation: string;
    mediaType: string;
    imageGallery: string[];
    pptDetails: {
      pptLink: string;
      pdfLink: string;
    };
    _id: string;
  };
}

export function UserProductCard({ item }: props) {
  const [isView, setIsView] = React.useState(false);
  function handleClose() {
    setIsView(false);
  }

  // console.log(item.stage);

  return (
    <>
      <div
        className="bg-[#eef2f700] boxes rounded-xl border overflow-hidden cursor-pointer w-full"
        onClick={() => setIsView(true)}
      >
        <div className="flex items-center gap-0.5 h-max font-medium p-2 pt-3 bg-white ">
          <span
            className={`flex  ${item.stage === 'Postsale' ? "bg-black" : item.stage === 'Presale' ? "bg-gray-400" : "bg-[#DA1A42]"} w-1 m-1 aspect-square h-max p-1.5 rounded-full`}
          ></span>
          {item.stage}
        </div>
        {item.mediaType === "ppt" ? (
          item?.pptDetails?.pdfLink && item.pptDetails.pdfLink.trim() !== "" ? (
            <div 
              className="w-[250px] xl:w-[300px] 2xl:w-[350px] min-w-full h-[150px] flex justify-center items-center rounded-xl overflow-hidden bg-gray-50 pdf-list-viewer-container"
              style={{ pointerEvents: 'none' }}
              onWheel={(e) => e.stopPropagation()}
              onScroll={(e) => e.stopPropagation()}
            >
              {item?.pptDetails?.pdfLink && item.pptDetails.pdfLink.trim() !== "" ? (
                <Worker workerUrl={`https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js`}>
                  <div style={{ 
                    width: '100%', 
                    height: '150px', 
                    overflow: 'hidden',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <Viewer
                      fileUrl={item.pptDetails.pdfLink}
                      initialPage={1}
                      defaultScale={0.45}
                    />
                  </div>
                </Worker>
              ) : (
                <div className="w-full h-full flex items-center justify-center bg-gray-200">
                  <p className="text-gray-500 text-sm">No PDF available</p>
                </div>
              )}
            </div>
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-gray-200">
              <p className="text-gray-500 text-sm">No PDF available</p>
            </div>
          )
        ) : (
          <img src={item.thumbLink || item.imageGallery[0]} alt="thumbnail" className="mx-auto" />
        )}
        <p className="h-full bg-white text-[14px] font-bold p-4">
          {item.title}
        </p>
      </div>
      {isView && (
        <VideoPopup open={isView} handleClose={handleClose} item={item as unknown as CreativeType} />
      )}
    </>
  );
}
